import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const Cpt3Editor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    // Parse the value - allow empty strings and invalid numbers to pass through
    const numericValue = value === '' ? 0 : parseFloat(value);
    
    // Update Redux with the numeric value (0 for empty) but only if it's valid or empty
    if (value === '' || (!isNaN(numericValue) && isFinite(numericValue))) {
      dispatch(updateSelectedContract({
        multipliers: {
          ...contract.multipliers,
          cpt3: numericValue
        }
      }));
    }
  };

  if (!contract) return null;

  const currentValue = contract.multipliers?.cpt3 ?? 100;

  return (
    <TextField
      label="CPT 3 Multiplier"
      value={currentValue === 0 ? '' : currentValue}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 1,
        min: 0
      }}
      fullWidth
      size="small"
      variant="outlined"
    />
  );
};

export default Cpt3Editor;
